<div class="identity-detail-container" [testId]="'identity-detail-container'">
  <!-- 加载中 -->
  <nz-spin [nzSpinning]="loading" [nzTip]="'common.loading' | i18n" [testId]="'identity-detail-loading-spin'">
    <!-- 内容区域 -->
    <div class="detail-content" [testId]="'identity-detail-content'">
      <form nz-form [formGroup]="identityForm" class="form-container" [testId]="'identity-detail-form'">
        <nz-card [testId]="'identity-detail-card'">
          <div class="card-header" [testId]="'identity-detail-card-header'">
            <h3 [testId]="'identity-detail-title'">{{ 'servicenumber.identity.info' | i18n }}</h3>
          </div>
          <nz-divider [testId]="'identity-detail-divider'" />

          <div nz-row [nzGutter]="24" [testId]="'identity-detail-form-row'">
            <div nz-col [nzSpan]="24" [testId]="'identity-detail-form-col'">
              <!-- 身份名称 -->
              <nz-form-item [testId]="'identity-detail-name-form-item'">
                <nz-form-label nzRequired nzFor="name" [testId]="'identity-detail-name-label'">{{
                  'servicenumber.identity.name' | i18n
                }}</nz-form-label>
                <nz-form-control [nzErrorTip]="'servicenumber.identity.name-required' | i18n" [testId]="'identity-detail-name-control'">
                  <input
                    nz-input
                    formControlName="name"
                    id="name"
                    [placeholder]="'servicenumber.identity.name-placeholder' | i18n"
                    [testId]="'identity-detail-name-input'"
                  />
                </nz-form-control>
              </nz-form-item>

              <!-- 身份类型 -->
              <nz-form-item [testId]="'identity-detail-type-form-item'">
                <nz-form-label nzRequired nzFor="type" [testId]="'identity-detail-type-label'">{{
                  'servicenumber.identity.type' | i18n
                }}</nz-form-label>
                <nz-form-control [nzErrorTip]="'servicenumber.identity.type-required' | i18n" [testId]="'identity-detail-type-control'">
                  <nz-select
                    formControlName="type"
                    id="type"
                    [nzPlaceHolder]="'servicenumber.identity.type-placeholder' | i18n"
                    [testId]="'identity-detail-type-select'"
                  >
                    <nz-option
                      *ngFor="let option of typeOptions"
                      [nzValue]="option.value"
                      [nzLabel]="option.label"
                      [testId]="'identity-detail-type-option-' + option.value"
                    />
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
              <!-- 头像上传区域 -->
              <nz-form-item [testId]="'identity-detail-avatar-form-item'">
                <nz-form-label nzRequired [testId]="'identity-detail-avatar-label'">{{
                  'servicenumber.identity.avatar' | i18n
                }}</nz-form-label>
                <nz-form-control [nzErrorTip]="'servicenumber.identity.avatar-required' | i18n" [testId]="'identity-detail-avatar-control'">
                  <div class="avatar-upload-container" [testId]="'identity-detail-avatar-upload-container'">
                    <div class="avatar-wrapper" (click)="showAvatarUploadModal()" [testId]="'identity-detail-avatar-wrapper'">
                      <ng-container *ngIf="!avatarUrl">
                        <div class="avatar-placeholder" [testId]="'identity-detail-avatar-placeholder'">
                          <i nz-icon nzType="user" nzTheme="outline" [testId]="'identity-detail-avatar-placeholder-icon'"></i>
                          <p [testId]="'identity-detail-avatar-placeholder-text'">{{ 'servicenumber.identity.upload-avatar' | i18n }}</p>
                        </div>
                      </ng-container>
                      <img *ngIf="avatarUrl" [src]="avatarUrl" class="avatar-image" [testId]="'identity-detail-avatar-image'" />
                      <div
                        class="avatar-upload-btn"
                        [nz-tooltip]="'servicenumber.identity.upload-avatar-tooltip' | i18n"
                        [testId]="'identity-detail-avatar-upload-btn'"
                      >
                        <i nz-icon nzType="camera" nzTheme="outline" [testId]="'identity-detail-avatar-upload-icon'"></i>
                      </div>
                    </div>
                    <div class="avatar-hint" [testId]="'identity-detail-avatar-hint'">{{
                      'servicenumber.identity.avatar-size-hint' | i18n
                    }}</div>
                  </div>
                </nz-form-control>
              </nz-form-item>

              <!-- 默认身份 -->
              <nz-form-item [testId]="'identity-detail-default-form-item'">
                <nz-form-label nzFor="isDefault" [testId]="'identity-detail-default-label'">{{
                  'servicenumber.identity.is-default' | i18n
                }}</nz-form-label>
                <nz-form-control [testId]="'identity-detail-default-control'">
                  <nz-switch formControlName="isDefault" [testId]="'identity-detail-default-switch'" />
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <!-- 底部按钮区域 -->
          <div class="footer-buttons" [testId]="'identity-detail-footer-buttons'">
            <button nz-button (click)="cancel()" [testId]="'identity-detail-cancel-btn'">{{ 'common.cancel' | i18n }}</button>
            <button nz-button nzType="primary" (click)="saveIdentity()" [nzLoading]="submitting" [testId]="'identity-detail-save-btn'">{{
              'common.save' | i18n
            }}</button>
          </div>
        </nz-card>
      </form>
    </div>
  </nz-spin>
</div>

<!-- 添加头像上传模态框 -->
<avatar-upload-modal
  [(visible)]="isAvatarModalVisible"
  [title]="'servicenumber.identity.upload-avatar-title' | i18n"
  [uploading]="isAvatarUploading"
  [aspectRatio]="1"
  [resizeToWidth]="300"
  (cancel)="handleAvatarModalCancel()"
  (ok)="handleAvatarCropped($event)"
  [testId]="'identity-detail-avatar-upload-modal'"
/>
